
import { defineComponent } from "vue";
import { getPostInfo } from "@/views/post/api/index.ts";
import commentOne from "@/views/post/components/commentOne.vue";
import pagination from "@/views/post/components/pagination.vue";
import toast from "@/views/post/components/toast.vue";
import editor from "@/views/post/components/editor.vue";

declare global {
  interface Window {
    CSRF_TOKEN: any;
    senseFn: any;
  }
}
export default defineComponent({
  components: {
    commentOne,
    pagination,
    editor,
    toast
  },
  data() {
    return {
      page: 1,
      comment: Array<any>(),
      limit: 15, //每页显示条数
      total: 0,
      post_id: "",
      csrf: ""
    };
  },
  methods: {
    getList(e = 0) {
      if (e) {
        this.page = e;
      }
      getPostInfo({
        post_id: this.post_id,
        page: this.page
      }).then(({ errorCode, errorMsg, responseData }) => {
        if (errorCode === 0) {
          this.comment = responseData.list;
          this.total = responseData.total
            ? parseInt(responseData.total)
            : this.total;
          this.csrf = responseData.csrf;
          if (e) {
            this.topFunction()
          }
        } else {
          (this.$refs.toast as any).show(errorMsg);
        }
      });
    },
    uplist(list: Array<any>, csrf: any) {
      this.comment.unshift(list);
      this.csrf = csrf;
    },
    topFunction() {
      const top = (document.querySelector(".comment") as any ).offsetTop - 100;
      document.body.scrollTop = top
      document.documentElement.scrollTop = top
    }
  },
  async created() {
    this.post_id = window.location.pathname.match(/\d+/g)
      ? (window.location.pathname.match(/\d+/g) as any)[0]
      : "";
    if (this.post_id) {
      this.getList();
    }
  }
});
